import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const items = [
  {
    quote:
      "IncInk helped in get our small business online, helped improve our social media brand and increased sale targets by a margin.",
    name: "Maya R.",
    role: "Founder, Beam Analytics",
    color: "#FFD800",
  },
  {
    quote:
      "Half the cost of an agency, twice the craft. Async daily updates, hard deadlines met. I'd hire again tomorrow.",
    name: "Raj S.",
    role: "Owner, Waves Gym",
    color: "#00E5FF",
  },
  {
    quote:
      "The landing page paid for itself in 11 days. Bold work that finally doesn't look like the same SaaS template.",
    name: "Priya S.",
    role: "CMO, Inkwell Labs",
    color: "#FF0055",
    light: true,
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 sm:py-32 px-4 sm:px-6"
    >
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#4A4A4A]">
              [05] — Kind words
            </span>
            <h2 className="mt-3 font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter">
              Receipts <br />
              from clients.
            </h2>
          </div>
          <div className="flex items-center gap-2 font-mono text-sm">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={20} fill="#FFD800" strokeWidth={1.5} />
            ))}
            <span className="ml-2 text-[#4A4A4A]">4.8 across 30+ projects</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className={`relative brut-border brut-shadow p-7 brut-lift ${
                i === 1 ? "md:translate-y-6" : ""
              }`}
              style={{ background: t.color, color: t.light ? "white" : "#0D0D0D" }}
            >
              <Quote size={28} className="opacity-70" />
              <blockquote className="mt-4 font-body text-lg leading-relaxed">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div
                  className="w-10 h-10 brut-border font-display font-black flex items-center justify-center"
                  style={{ background: t.light ? "white" : "#FDFBF7", color: "#0D0D0D" }}
                >
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-display font-black uppercase text-sm">
                    {t.name}
                  </div>
                  <div className={`font-mono text-xs uppercase tracking-widest ${t.light ? "text-white/80" : "text-[#0D0D0D]/70"}`}>
                    {t.role}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
